<template>
  <div class="w-full p-5 bg-white rounded-lg shadow-card">
    <h3 class="font-primary font-extrabold text-blue-brand text-28 md:text-32 leading-1 -tracking-1/2 mb-5">{{ invoice.code }}</h3>
    <div class="hidden md:flex">
      <p class="label w-1/2">Item</p>
      <p class="label text-center flex-grow">Qty</p>
      <p class="label text-center w-1/5">Amount</p>
      <p class="label text-center w-1/5">Total</p>
    </div>
    <template v-if="invoice.lines.length > 0">
      <account-invoice-item v-for="(item, index) in invoice.lines" :key="index" :item="item" :currency="invoice.currency"></account-invoice-item>
    </template>
    <div class="py-5 flex items-center justify-between">
      <p class="font-primary font-extrabold text-blue-dark text-28 leading-1">Total</p>
      <p class="font-primary font-extrabold text-blue-dark text-28 leading-1">{{ total }}</p>
    </div>
    <p v-if="errorMessage" class="text-red-500">
      {{  errorMessage }}
    </p>
    <template v-if="outstanding">
      <a v-if="invoice.payable" :disabled="gettingFormDetails" href="#" class="button bg-yellow-brand text-blue-dark transition-colors hover:bg-yellow-light min-w-0 w-full" @click.prevent="doPayment">Pay invoice</a>
      <div v-else>
        <p class="my-5 text-center text-16 leading-1.63">Invoice requires action before payment can be taken.</p>
        <button :disabled="true" class="button bg-yellow-brand text-blue-dark transition-colors hover:bg-yellow-brand min-w-0 w-full opacity-50">Pay invoice</button>
      </div>
    </template>
    <template v-else>
      <p class="font-primary font-extrabold text-blue-brand text-28 md:text-32 leading-1 -tracking-1/2 text-center uppercase">{{ invoice.status }}</p>
    </template>

    <invisible-payment-form :details="paymentFormDetails"></invisible-payment-form>
  </div>
</template>

<script>
import AccountInvoiceItem from './AccountInvoiceItem.vue';
import InvisiblePaymentForm from './InvisiblePaymentForm.vue';
import { formatPrice } from '../src/Helpers.js';
import Route from '../src/Route';
import get from 'lodash/get';

export default {
  components: { AccountInvoiceItem, InvisiblePaymentForm },

  data() {
    return {
      gettingFormDetails: false,
      errorMessage: null,
      errors: [],
      paymentFormDetails: null,
    };
  },

  props: {
    invoice: {
      type: Object,
      required: true,
    },
    outstanding: {
      type: Boolean,
      required: true,
    },
  },

  computed: {
    total() {
      if (this.invoice.currency === 'GBP') {
        return `£${this.readablePrice(this.invoice.total)}`
      }

      else if (this.invoice.currency === 'USD') {
        return `$${this.readablePrice(this.invoice.total)}`
      }
    },
  },

  methods: {
    readablePrice(price) {
      return formatPrice(price);
    },

    doPayment() {
      this.gettingFormDetails = true;
      this.errors = [];
      this.errorMessage = null;

      axios
        .get(Route('json.payments.show'), {
          params: {
            invoice_ids: [this.invoice.uuid]
          }
        })
        .then((response) => {
          if (response.status !== 200) {

            throw 'Error.';
          }

          // Setting this will create the form which
          // will automatically submit itself
          this.paymentFormDetails = response.data.worldpay_details;
        })
        .catch(e => {
          if ([422, 403].includes(get(e, 'response.status'))) {
            this.errors = get(e, 'response.data.errors');
            this.errorMessage = get(e, 'response.data.message');
          }
          console.error(e)
        })
        .then(() => {
          this.gettingFormDetails = false;
        });
    }
  },
}
</script>
